import { Injectable } from '@angular/core';
import { buildOfficerSelectOptions } from '@app/finxone-web-frontend/app/lib/utils/companies-house-officer.utils';
import { LookupType, LookupsCommonType } from '@finxone-platform/shared/sys-config-types';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { MOCK_COMPANIES_HOUSE_OFFICERS } from '../../../../libs/services/ngxs-mock-data-provider/companies-house-officers.mock-data';

@Injectable({
  providedIn: 'root',
})
export class MockDataSourceService {
  private _dataSources: { [key: string]: LookupsCommonType[] } = {
    titles: [
      {
        value: '1',
        label: 'Mr',
      },
      {
        value: '2',
        label: 'Mrs',
      },
      {
        value: '3',
        label: 'Miss',
      },
      {
        value: '4',
        label: 'Ms',
      },
      {
        value: '5',
        label: 'Dr',
      },
      {
        value: '6',
        label: 'Prof',
      },
    ],
    'source-of-funds': [
      {
        value: '1',
        label: 'Empl Inc Saving',
      },
      {
        value: '2',
        label: 'Gambling income',
      },
      {
        value: '3',
        label: 'Gift',
      },
      {
        value: '4',
        label: 'Inheritance',
      },
      {
        value: '5',
        label: 'Investment inc.',
      },
      {
        value: '6',
        label: 'Other empl. inc',
      },
      {
        value: '7',
        label: 'Sale of assets',
      },
    ],
    countries: [
      {
        value: 'GB',
        label: 'United Kingdom',
      },
      {
        value: 'US',
        label: 'United States',
      },
      {
        value: 'CA',
        label: 'Canada',
      },
      {
        value: 'AU',
        label: 'Australia',
      },
      {
        value: 'DE',
        label: 'Germany',
      },
      {
        value: 'FR',
        label: 'France',
      },
      {
        value: 'IT',
        label: 'Italy',
      },
      {
        value: 'ES',
        label: 'Spain',
      },
      {
        value: 'NL',
        label: 'Netherlands',
      },
      {
        value: 'BE',
        label: 'Belgium',
      },
    ],
    'account-purpose': [
      {
        value: '769',
        label: 'Everyday Savings',
      },
      {
        value: '770',
        label: 'Family',
      },
      {
        value: '747',
        label: 'Education',
      },
      {
        value: '771',
        label: 'House Deposit Improvements',
      },
      {
        value: '772',
        label: 'Car Motorbike',
      },
      {
        value: '773',
        label: 'Holiday',
      },
      {
        value: '716',
        label: 'Retirement',
      },
      {
        value: '774',
        label: 'Other',
      },
    ],
    [LookupType.COMPANIES_HOUSE_DIRECTORS]: buildOfficerSelectOptions(MOCK_COMPANIES_HOUSE_OFFICERS),
  };
  private dataSourcesSubject = new BehaviorSubject<{ [key: string]: LookupsCommonType[] }>({});

  public get dataSources(): { [key: string]: LookupsCommonType[] } {
    return this._dataSources;
  }

  public get dataSources$() {
    return this.dataSourcesSubject.asObservable();
  }

  public getDataSourceByType(type: string): Observable<LookupsCommonType[]> {
    return of(this._dataSources[type] || []);
  }
}
